import { wallsApi } from '@walls/services/wallsApi';
import type { WallCard } from '@walls/store';
import { isClusterCard } from '../selectors/boardCardSelectors';

export function updateCardOrClusterPosition(
  boardId: string,
  cards: WallCard[],
  cardId: string,
  xPos: number,
  yPos: number,
  topicKey: string | null
) {
  const card = findCardInTree(cards, cardId);

  if (card && isClusterCard(card)) {
    return wallsApi.updateClusterPosition(
      boardId,
      cardId,
      { clusterId: cardId, xPos, yPos },
      topicKey
    );
  }

  return wallsApi.updateCardPosition(boardId, cardId, { id: cardId, xPos, yPos }, topicKey);
}

function findCardInTree(cards: WallCard[], cardId: string): WallCard | null {
  for (const card of cards) {
    if (card.id === cardId) {
      return card;
    }

    const childCard = findCardInTree(card.cards, cardId);

    if (childCard) {
      return childCard;
    }
  }

  return null;
}
